import { Step, StepButton, Stepper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { SimpleFormView } from "react-admin";

const triggerFieldsToShowErrors = (form) => {
	const fieldNames = form.getRegisteredFields();
	form.batch(() => {
		fieldNames.forEach((fieldName) => {
			form.focus(fieldName);
			form.blur(fieldName);
		});
	});
};

const useStyles = makeStyles((theme) => ({
	stepper: {
		width: "100%",
		boxSizing: "border-box",
	},
}));

export const WizardFormView = ({
	steps,
	toolbarComponent: ToolbarComponent,
	defaultStepNumber = 0,
	saveDisabled,
	...formProps
}) => {
	const [activeStep, setActiveStep] = useState(defaultStepNumber);
	const [triedForward, setTriedForward] = useState(false);
	const classes = useStyles();
	const canMoveForward = formProps.valid;
	const isNextDisabled = triedForward && !formProps.valid;

	const nextCallback = () => {
		triggerFieldsToShowErrors(formProps.form);
		if (formProps.valid) setTriedForward(false);
		else setTriedForward(true);
	};

	const handleMoveNext = (step) => () => {
		nextCallback();
		if (step < activeStep || canMoveForward) setActiveStep(step);
	};

	return (
		<SimpleFormView
			{...formProps}
			toolbar={
				<ToolbarComponent
					save={formProps.save}
					activeStep={activeStep}
					setActiveStep={setActiveStep}
					stepsLength={steps.length}
					canMoveForward={canMoveForward}
					isNextDisabled={isNextDisabled}
					nextCallback={nextCallback}
					saveDisabled={saveDisabled}
				/>
			}
		>
			<Stepper nonLinear={!isNextDisabled} className={classes.stepper} activeStep={activeStep}>
				{steps.map((step, index) => (
					<Step key={index}>
						<StepButton onClick={handleMoveNext(index)}>{step.props.label}</StepButton>
					</Step>
				))}
			</Stepper>

			{steps[activeStep]}
		</SimpleFormView>
	);
};
